module.exports = __webpack_public_path__ + "static/media/53041418_2452976588110851_8775738261659189248_o.2e11b01d.jpg";